export enum ToastStatusTypes {
  DANGER = "danger",
  INFO = "info",
  PRIMARY = 'primary',
  SUCCESS = "success",
  WARNING = 'warning'
}

export class Toast {

  private static readonly _instance = new Toast();

  private toastEl: HTMLElement;
  private timeoutId: number;
  private prevStatus: ToastStatusTypes;

  constructor() {
    this.toastEl = document.getElementById('toast');

    const closeBtn = this.toastEl?.querySelector('#close-btn');
    closeBtn?.addEventListener('click', () => this.resetToast());
  }

  static get instance() {
    return this._instance;
  }
  
  private resetToast() {
    clearInterval(this.timeoutId);
    this.toastEl.classList.remove('show', `bg-${this.prevStatus}`);
    this.toastEl.offsetHeight;
  }

  show(status: ToastStatusTypes, message: string) {

    this.resetToast();

    this.prevStatus = status;
    this.toastEl.classList.add('show', `bg-${status}`);
    this.toastEl.querySelector('#toast-message').textContent = message;

    this.timeoutId = setTimeout(() => {
      this.toastEl.classList.remove('show');
    }, 4000);
  }
}
